<template>
  <div class="page page--fill">
    <data-list
      title="Lots"
      :resource="resource"
      :columns="columns"
      :filters="filters">
      <template #summary>
        <kpi-row :items="kpis" />
      </template>
      <template #ref="{ item }">
        <span class="cell-strong">{{ item.ref }}</span>
      </template>
      <template #status="{ item }">
        <span :class="pillClass(LOT_STATUS, item.status)">{{ labelOf(LOT_STATUS, item.status) }}</span>
      </template>
      <template #program="{ item }">
        <template v-if="item.program">
          <div>{{ item.program.name }}</div>
          <div class="cell-muted">
            {{ item.program.address && item.program.address.city }}
          </div>
        </template>
      </template>
    </data-list>
  </div>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import DataList from '../components/DataList'
  import KpiRow from '../components/KpiRow'
  import { LOT_STATUS, toOptions, pillClass, labelOf } from '../labels'

  const price = value => (value ? `${Math.round(value).toLocaleString('fr-FR')} €` : '—')

  export default {
    name: 'LotList',
    components: { DataList, KpiRow },
    data () {
      return {
        kpis: [
          { label: 'Lots', resource: RESOURCES.LOT, params: {} },
          { label: 'Disponibles', resource: RESOURCES.LOT, params: { status: 'available' } },
          { label: 'Optionnés', resource: RESOURCES.LOT, params: { status: 'optioned' } },
          { label: 'Réservés', resource: RESOURCES.LOT, params: { status: 'reserved' } },
          { label: 'Vendus', resource: RESOURCES.LOT, params: { status: 'sold' } }
        ],
        LOT_STATUS,
        resource: RESOURCES.LOT,
        columns: [
          { key: 'ref', label: 'Lot', width: 100 },
          { key: 'status', label: 'Statut', width: 130 },
          { key: 'program', label: 'Programme' },
          { key: 'lot_type', label: 'Typologie', width: 110 },
          { key: 'surface', label: 'Surface', width: 100, align: 'end', format: v => (v ? `${v} m²` : '—') },
          { key: 'sale_price_ht', label: 'Prix HT', width: 130, align: 'end', format: (v, item) => price(v || item.sales_price_ht) },
          { key: 'sale_price_ttc', label: 'Prix TTC', width: 130, align: 'end', format: (v, item) => price(v || item.sales_price_ttc) }
        ],
        filters: [
          { key: 'ref', type: 'search', label: 'Référence exacte', width: 200 },
          { key: 'status', type: 'select', label: 'Statut', items: toOptions(LOT_STATUS) },
          { key: 'program', type: 'remote', label: 'Programme', resource: RESOURCES.PROGRAM },
          { key: 'promoteur', type: 'remote', label: 'Promoteur', resource: RESOURCES.ACCOUNT }
        ]
      }
    },
    methods: {
      pillClass,
      labelOf
    }
  }
</script>
